import React, { useState, useEffect } from 'react';
import HeaderCardNew from '../../Components/HeaderCardNew';
import CarouselSmallCard from '../../Components/CarouselSmallCard';
import BannerCard from '../../Components/BannerCard';
import BottomNavBarNew from "../../Components/BottomNavBarNew";
import styles from './LibraryAbortionMenu.module.css';
import TopNavBarNew from "../../Components/TopNavBarNew";

export default function LibraryAbortionMenu({ appLanguage }) {
  const [pageState, setPageState] = useState({
    title: '',
    title2: '',
    title3: '',
    title4: '',
    title5: '',
    extraText: '',
    extraText2: '',
    extraText3: '',
    extraText4: '',
    extraText5: '',
    card1Title: '',
    card1Description: '',
    card2Title: '',
    card2Description: '',
    smallCard1Title: '',
    smallCard2Title: '',
    smallCard3Title: '',
    smallCard4Title: '',
    smallCard5Title: '',
    smallCard6Title: '',
    smallCard7Title: '',
    smallCard8Title: '',
    smallCard9Title: '',
    smallCard10Title: '',
    carouselOneCards: [],
    carouselTwoCards: [],
    carouselThreeCards: [],
    headerImage: '',
    card2Image: '',
    arrowIconDark: '',
    arrowIconWhite: '',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Library Abortion Menu';

    // Direct localStorage reading
    const entries = JSON.parse(localStorage.getItem('ayaAppEntries') || '[]');
    const assets = JSON.parse(localStorage.getItem('ayaAppAssets') || '[]');

    // Add inline helper function
    const getEntryField = (entryId, field, language = appLanguage || 'es-VE') => {
      const entry = entries.find(e => e.sys.id === entryId);
      if (!entry?.fields?.[field]) return '';
      const fieldValue = entry.fields[field];
      if (typeof fieldValue === 'object' && fieldValue[language]) {
        return fieldValue[language];
      }
      return fieldValue;
    };

    const getAssetUrl = (assetId, language = appLanguage || 'es-VE') => {
      const asset = assets.find(a => a.sys.id === assetId);
      if (!asset?.fields?.file) return '';
      const localizedFile = asset.fields.file[language];
      if (localizedFile?.url) {
        const url = localizedFile.url;
        return url.startsWith('//') ? `https:${url}` : url;
      }
      const fallbackFile = Object.values(asset.fields.file)[0];
      if (fallbackFile?.url) {
        const url = fallbackFile.url;
        return url.startsWith('//') ? `https:${url}` : url;
      }
      return '';
    };

    const entryId = "3oBQfcxfr3rBNhYbssPro";

    // Get specific entry by ID (following class component pattern)
    const getPageEntries = entries.find(obj => obj.sys.id === entryId);

    if (getPageEntries) {
      setPageState({
        title: getEntryField(entryId, 'title') || '',
        title2: getEntryField(entryId, 'title2') || '',
        title3: getEntryField(entryId, 'title3') || '',
        title4: getEntryField(entryId, 'title4') || '',
        title5: getEntryField(entryId, 'title5') || '',
        extraText: getEntryField(entryId, 'extraText') || '',
        extraText2: getEntryField(entryId, 'extraText2') || '',
        extraText3: getEntryField(entryId, 'extraText3') || '',
        extraText4: getEntryField(entryId, 'extraText4') || '',
        extraText5: getEntryField(entryId, 'extraText5') || '',
        card1Title: getEntryField(entryId, 'card1Title') || '',
        card2Title: getEntryField(entryId, 'card2Title') || '',
        card1Description: getEntryField(entryId, 'card1Description') || '',
        card2Description: getEntryField(entryId, 'card2Description') || '',
        smallCard1Title: getEntryField(entryId, 'smallCard1Title') || '',
        smallCard2Title: getEntryField(entryId, 'smallCard2Title') || '',
        smallCard3Title: getEntryField(entryId, 'smallCard3Title') || '',
        smallCard4Title: getEntryField(entryId, 'smallCard4Title') || '',
        smallCard5Title: getEntryField(entryId, 'smallCard5Title') || '',
        smallCard6Title: getEntryField(entryId, 'smallCard6Title') || '',
        smallCard7Title: getEntryField(entryId, 'smallCard7Title') || '',
        smallCard8Title: getEntryField(entryId, 'smallCard8Title') || '',
        smallCard9Title: getEntryField(entryId, 'smallCard9Title') || '',
        smallCard10Title: getEntryField(entryId, 'smallCard10Title') || '',
        smallCardLinks: [
          "/abor-before-whatpillsdoineed",
          "/abor-before-whattoexpect",
          "/abor-before-howtopreparemyself",
          "/abor-during-usemifeandmiso",
          "/abor-during-usemiso",
          "/abor-during-warningsigns",
          "/abor-after-test",
          "/abor-after-managingemotions",
          "/contra-library",
        ],
        headerImage: getAssetUrl("01OKOkJKnkhbdVZXksKyej") || '',
        card2Image: getAssetUrl("6MDel9UZPwTHEOX92BCVU0") || '',
        arrowIconDark: getAssetUrl("35s9SZBtTGy9KGs0lc41lt") || '',
        arrowIconWhite: getAssetUrl("5t0SZSeDrtBlIZ3o0Apjcu") || '',
      
        carouselOneCards: [
          {
            title: getEntryField(entryId, 'smallCard1Title') || '',
            extraText: getEntryField(entryId, 'extraText3') || '',
            icon: getAssetUrl("35s9SZBtTGy9KGs0lc41lt") || '',
            link: "/abor-before-whatpillsdoineed",
          },
          {
            title: getEntryField(entryId, 'smallCard2Title') || '',
            extraText: getEntryField(entryId, 'extraText3') || '',
            icon: getAssetUrl("35s9SZBtTGy9KGs0lc41lt") || '',
            link: "/abor-before-whattoexpect",
          },
          {
            title: getEntryField(entryId, 'smallCard3Title') || '',
            extraText: getEntryField(entryId, 'extraText2') || '',
            icon: getAssetUrl("35s9SZBtTGy9KGs0lc41lt") || '',
            link: "/abor-before-howtopreparemyself",
          },
        ],
        carouselTwoCards: [
          {
            title: getEntryField(entryId, 'smallCard4Title') || '',
            extraText: getEntryField(entryId, 'extraText4') || '',
            icon: getAssetUrl("35s9SZBtTGy9KGs0lc41lt") || '',
            link: "/abor-during-usemifeandmiso",
          },
          {
            title: getEntryField(entryId, 'smallCard5Title') || '',
            extraText: getEntryField(entryId, 'extraText4') || '',
            icon: getAssetUrl("35s9SZBtTGy9KGs0lc41lt") || '',
            link: "/abor-during-usemiso",
          },
          {
            title: getEntryField(entryId, 'smallCard6Title') || '',
            extraText: getEntryField(entryId, 'extraText3') || '',
            icon: getAssetUrl("35s9SZBtTGy9KGs0lc41lt") || '',
            link: "/abor-during-warningsigns",
          },
        ],
        carouselThreeCards: [
          {
            title: getEntryField(entryId, 'smallCard8Title') || '',
            extraText: getEntryField(entryId, 'extraText2') || '',
            icon: getAssetUrl("35s9SZBtTGy9KGs0lc41lt") || '',
            link: "/tracker-onboarding-welcome",
          },
          {
            title: getEntryField(entryId, 'smallCard9Title') || '',
            extraText: getEntryField(entryId, 'extraText2') || '',
            icon: getAssetUrl("35s9SZBtTGy9KGs0lc41lt") || '',
            link: "/abor-after-test",
          },
          {
            title: getEntryField(entryId, 'smallCard10Title') || '',
            extraText: getEntryField(entryId, 'extraText5') || '',
            icon: getAssetUrl("35s9SZBtTGy9KGs0lc41lt") || '',
            link: "/abor-after-managingemotions",
          },
        ],
      });
    }
  }, [appLanguage]);

  return (
    <div className={styles.homePageContainer}>
      <div className={styles.libraryAbortionMenuContainer}>
        <TopNavBarNew backgroundColor="#FDE8D8" breadcrumbColor="#333" />
          {/* Header Section */}
          <div className={styles.headerContainer}>
          <HeaderCardNew
              title={pageState.title}
              image={pageState.headerImage}
              backgroundColor="#FDE8D8" 
              borderRadius="0px" 
            />
          </div>

        <div className={styles.contentWrapper}>
        <BannerCard 
            title={pageState.card1Title} 
            description={pageState.card1Description}
            image={pageState.arrowIconWhite}
            gradient="linear-gradient(102deg, #E12541 42.2%, #F85833 82.58%)"
            link="/eligibility-start"
            imageWidth="26px"
            imageHeight="26px"
            imagePosition="right"
            /* imagePlacement="top" */
            titleMaxWidth="256px"
            /* descriptionMaxWidth="286px" */
            cardWidth="350px"
            cardHeight="95px"
            /* titlePaddingTop="10px" */
            /* descriptionPaddingBottom="10px" */
            titleFontSize="14px"
            titleFontWeight="700"
            titleColor="#FFFFFF"
            titleLineHeight="15px"
            /* descriptionFontSize="13px"
            descriptionFontWeight="400" */
            descriptionColor="#FFFFFF"
          />

          {/* First Carousel Section */}
          <div className={styles.exploraContainer}>
            <div className={styles.sectionTitleExplora}>{pageState.title2}</div>
            <div className={styles.scrollInfo}>{pageState.extraText}</div>
          </div>
          <div className={styles.carouselContainer}>
                  {pageState.carouselOneCards.map((card, index) => (
                    <CarouselSmallCard
                      key={index}
                      title={card.title}
                      extraText={card.extraText}
                      icon={card.icon}
                      link={card.link}
                      spacingBetweenTitleAndExtraText="20px"
                    />
                  ))}
                </div>

                  {/* Second Carousel Section */}
                  <div className={styles.exploraContainer}>
                    <div className={styles.sectionTitleExplora}>{pageState.title3}</div>
                    <div className={styles.scrollInfo}>{pageState.extraText}</div>
                  </div>
                  <div className={styles.carouselContainer}>
                          {pageState.carouselTwoCards.map((card, index) => (
                            <CarouselSmallCard
                              key={index}
                              title={card.title}
                              extraText={card.extraText}
                              icon={card.icon}
                              link={card.link}
                              spacingBetweenTitleAndExtraText="20px"
                            />
                          ))}
                        </div>
                  {/*       <div className={styles.bannerCardWrapper}>
                        <BannerCard 
                            title={pageState.card2Title} 
                            description={pageState.card2Description}
                            image={pageState.card2Image}
                            gradient="linear-gradient(99deg, #4450E5 22.9%, #616CEE 77.43%)"
                            link="/tracker-onboarding-welcome"
                            imageWidth="120px"
                            imageHeight="113.582px"
                            imagePosition="right"
                            titleMaxWidth="300px"
                            descriptionMaxWidth="300px"
                            isWideBanner={true}

                            titleFontSize="14px"
                            titleFontWeight="700"
                            titleColor="#FFFFFF"
                            titleLineHeight="16px"
                            titleWidth="212px"
                            titleHeight="41px"

                            descriptionFontSize="12.5px"
                            descriptionFontWeight="400"
                            descriptionColor="#FFFFFF"
                            descriptionLineHeight="13px"
                            descriptionWidth="256px"
                            descriptionHeight="27px"
                          />
                          </div> */}

                        {/* Third Carousel Section */}
                        <div className={styles.exploraContainer}>
                          <div className={styles.sectionTitleExplora}>{pageState.title4}</div>
                          <div className={styles.scrollInfo}>{pageState.extraText}</div>
                        </div>
                        <div className={styles.carouselContainer}>
                                {pageState.carouselThreeCards.map((card, index) => (
                                  <CarouselSmallCard
                                    key={index}
                                    title={card.title}
                                    extraText={card.extraText}
                                    icon={card.icon}
                                    link={card.link}
                                    spacingBetweenTitleAndExtraText="20px"
                                  />
                                ))}
                              </div>
          </div>
      </div>

                        <div className={styles.bottomSpace}></div>
                        <BottomNavBarNew appLanguage={appLanguage}/>
  </div>
);
}